// extracted by mini-css-extract-plugin
export var phone = "_2q-0";
export var phoneDragging = "_2q-1";